import axios from "axios";
import { proxyServer } from "../assets/constantes";


export const getVariableByShortName = async (variableShortname)=>{
    
    try {
        const response = await axios.get(`${proxyServer}api/getVariableByShortName/${variableShortname}`);
        
        return response;
    } catch (error) {
        console.log(error);
        return error
    }
}